import React from 'react';

const Deadlines = ()=> (
    <div>
        <h2>Deadlines (AOE Time)</h2>
        <table>
          <tr>
            <td>Nov. 24, 2021</td>
            <td>Submission of regular Paper</td>
          </tr>
          <tr>
            <td>Feb. 06, 2022</td>
            <td>Rebuttal due from authors (7 days)</td>
          </tr>
          <tr>
            <td>Feb. 15, 2022</td>
            <td>Notification of paper acceptance</td>
          </tr>
          <tr>
            <td>Mar. 10, 2022</td>
            <td>Camera-ready papers due</td>
          </tr>
          <tr>
            <td>Mar. 31, 2022</td>
            <td>Author Registration deadline</td>
          </tr>
          <tr>
            <td>May 22-23, 2022</td>
            <td>Workshop</td>
          </tr>
        </table>
    </div>
);

export default Deadlines;